import React, { FC, useState } from "react";
import { DEF_PG_SIZE_WIZARD } from "../../../../constants/maximum-page-size";
import { useLocale } from "../../../../contexts/localeContext";
import { TableContextProvider } from "../../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import ZoneColumns from "../../../../models/ColumnDefinitions/ZoneColumns";
import { hideColumns } from "../../../../models/utilities/columnHelper";
import { getZones } from "../../../../services/zoneService";
import TableTab from "../../../tabs/table-tab";
import { useFormikContext } from "formik";

interface ZoneEntityProps {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    filterModalTrigger: string;
}

const ZoneEntity: FC<ZoneEntityProps> = ({ onBack, onNext }) => {
    const { translate } = useLocale();
    const [selectIds, setSelectIds] = useState<string[]>([]);
    const {setFieldValue} = useFormikContext<any>();

    const onSelectedIds = (selectedIds: string[]) => {
        setFieldValue('filterIds', selectedIds);
        setSelectIds([...selectedIds]);
    }  

    return <div className="pt-3 pr-3 pl-3 h-full">
        <TableContextProvider
            dataMethod={getZones}
            useTable
            usePagination
            useFilter
            useSearch
            useSort
            tableDescriptor={hideColumns(ZoneColumns, ["doors"])}
            searchDescriptor={ZoneColumns}
            maxPageSize={DEF_PG_SIZE_WIZARD}
            canExportReport={false}>
            <TableTab
                title={translate.byKey(TranslationKeys.zones)}
                selectRows={true}
                selectedIds={selectIds}
                setSelectedIds={onSelectedIds}
                tableId={'zoneEntity'}
                cyName="zoneEntity">
            </TableTab>
        </TableContextProvider>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type="button"
                    onClick={e => onNext(e)}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}

export default ZoneEntity;